module.exports = __webpack_public_path__ + "img/Pack Station (WMS Module)_Page_21.0f90fa49.jpg";